module.exports = "images/teamed_image_11.png";